import { MgState, RoleEntityInterface } from '@types';
import { PagePermissionEntityInterface } from '@types';
import { createSelector } from 'reselect';
import { currentUserRoleSelector, hasFeaturePermissionsSelectorFactory } from '@selectors/user';
import { FeaturePermission, PagePermission, PermissionActions } from '../../api/enums';

export const rolesSelector = (store: MgState): RoleEntityInterface[] => store?.role?.roles;

export const currentRolePermissionsSelector = (store: MgState): PagePermissionEntityInterface[] =>
  store?.role?.currentRolePermissions;

export const roleByIdSelector = (id: string) =>
  createSelector([rolesSelector], (roles) => roles.find((role) => role.id === id));

export const isRolePermissionsSaving = (store: MgState): boolean =>
  store.role.isRolePermissionsSaving;

export const isDeletingRoleLoading = (store: MgState): boolean => store.role.isDeletingRoleLoading;

export const roleIdForDelete = (store: MgState): string => store.role.roleIdForDelete;

export const canRemoveRoleSelector = (roleId: string) =>
  createSelector(
    [
      hasFeaturePermissionsSelectorFactory(
        PagePermission.Roles,
        [FeaturePermission.RoleItem],
        [PermissionActions.Remove]
      ),
      currentUserRoleSelector,
    ],
    (canRemove, currentUserRole) => {
      if (roleId === currentUserRole.id) {
        return false;
      }
      return canRemove;
    }
  );
